// OLERA — interactions. Vanilla, no dependencies.
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // Hero "pour" reveal once the bottle image is ready.
  const heroImg = $(".hero-media img");
  // Hero text is revealed directly (not via the observer) so it can never stay hidden.
  const loaded = () => {
    document.body.classList.add("is-loaded");
    $$(".hero .reveal").forEach((el, i) => {
      el.style.transitionDelay = `${200 + i * 120}ms`;
      el.classList.add("is-in");
    });
  };
  heroImg && heroImg.complete ? loaded() : heroImg?.addEventListener("load", loaded, { once: true });
  setTimeout(loaded, 1200);

  // Nav state + oil-level scroll indicator.
  const nav = $("[data-nav]");
  const level = $(".oil-level");
  const onScroll = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    level.style.setProperty("--p", max > 0 ? (scrollY / max).toFixed(4) : 0);
    nav.classList.toggle("is-scrolled", scrollY > 24);
  };
  addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Viscous scroll reveals, lightly staggered within a section.
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const siblings = $$(".reveal", e.target.closest("section, footer") || document.body);
        const i = Math.max(0, siblings.indexOf(e.target));
        e.target.style.transitionDelay = `${Math.min(i % 4, 3) * 110}ms`;
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
  );
  $$(".reveal").forEach((el) => io.observe(el));

  // Accessible tabs (formula + textures).
  $$("[data-tabs]").forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute("aria-selected", on);
        t.tabIndex = on ? 0 : -1;
        $("#" + t.getAttribute("aria-controls")).hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener("click", () => select(t));
      t.addEventListener("keydown", (e) => {
        const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (d) select(tabs[(i + d + tabs.length) % tabs.length], true);
        if (e.key === "Home") select(tabs[0], true);
        if (e.key === "End") select(tabs[tabs.length - 1], true);
      });
    });
  });

  // Film.
  const film = $("[data-film]");
  $("[data-film-play]")?.addEventListener("click", () => {
    film.controls = true;
    film.play();
    film.closest(".film").classList.add("is-playing");
  });

  // Purchase: plan × quantity (prices come from Shopify, in cents).
  const buyForm = $("[data-buy]");
  let qty = 1;
  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: window.Shopify?.currency?.active || "USD" }).format(cents / 100);
  const renderTotal = () => {
    if (!buyForm) return;
    const opt = $('input[name="selling_plan"]:checked', buyForm);
    $("[data-qty-val]", buyForm).textContent = qty;
    $("[data-qty-input]", buyForm).value = qty;
    const total = $("[data-total]", buyForm);
    if (opt && total) total.textContent = money(Number(opt.dataset.price) * qty);
  };
  if (buyForm) {
    $$("[data-qty]", buyForm).forEach((b) =>
      b.addEventListener("click", () => {
        qty = Math.min(9, Math.max(1, qty + Number(b.dataset.qty)));
        renderTotal();
      })
    );
    $$('input[name="selling_plan"]', buyForm).forEach((r) => r.addEventListener("change", renderTotal));
    renderTotal();
  }

  // Fill: scrubs the pour video with scroll through checkout. "Add to bag" completes it.
  const fill = $("[data-fill]");
  const fillVideo = $("[data-fill-video]");
  let completeFill = () => {};
  if (fill && fillVideo) {
    const section = fill.closest("section");
    const grid = fill.closest(".grid");
    const mlEl = $("[data-fill-ml]");
    const note = $("[data-fill-note]");
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const mobile = matchMedia("(max-width: 900px)");
    let shown = 0;   // eased progress actually displayed
    let boost = 0;   // set to 1 once something is added to the bag
    let ready = false;

    // The real pour isn't linear (fast fill, slow top-off), so map the gauge's
    // fill level to the video time where the oil actually reaches that level.
    // Measured from fill.mp4: [level 0–1, seconds].
    const LEVELS = [[0, 0.05], [0.1, 0.3], [0.2, 0.4], [0.35, 0.53], [0.55, 0.67], [0.7, 0.8], [0.85, 0.95], [0.9, 1.2], [0.95, 1.6], [1, 1.95]];
    const levelToTime = (p) => {
      for (let i = 1; i < LEVELS.length; i++) {
        const [l1, t1] = LEVELS[i];
        if (p <= l1) {
          const [l0, t0] = LEVELS[i - 1];
          return t0 + ((p - l0) / (l1 - l0)) * (t1 - t0);
        }
      }
      return LEVELS[LEVELS.length - 1][1];
    };

    const target = () => {
      const vh = innerHeight;
      let p;
      if (mobile.matches) {
        // No pin on phones: fill as the bottle travels up the screen.
        const r = fill.getBoundingClientRect();
        p = (vh * 0.85 - r.top) / (r.height * 0.9);
      } else {
        // Desktop: the bottle pins (sticky); finish the pour before the pin releases.
        const g = grid.getBoundingClientRect();
        const pin = g.height - fill.offsetHeight - 104;
        p = (vh * 0.6 - g.top) / ((vh * 0.6 + pin) * 0.85);
      }
      return Math.max(boost, Math.min(1, Math.max(0, p)));
    };

    const paint = (p) => {
      fill.style.setProperty("--p", p.toFixed(4));
      mlEl.textContent = Math.round(p * 178);
      const full = p > 0.985;
      fill.classList.toggle("is-full", full);
      note.textContent = full ? "Filled fresh, bottle by bottle" : p > 0.01 ? "Pouring" : "Scroll to pour";
      if (ready && !fillVideo.seeking) {
        const t = Math.min(levelToTime(p), fillVideo.duration - 0.02);
        if (Math.abs(fillVideo.currentTime - t) > 1 / 60) fillVideo.currentTime = t;
      }
    };

    // Prime the decoder (iOS only paints seeked frames after a play attempt).
    fillVideo.addEventListener("loadedmetadata", () => {
      if (reduced) return;
      ready = true;
      fillVideo.play().then(() => fillVideo.pause()).catch(() => {});
      paint(shown);
    });

    if (reduced) {
      fillVideo.poster = fill.dataset.fullPoster;
      fillVideo.preload = "none";
      ready = false;
      paint(1);
    } else {
      // Only run the loop while the checkout is near the viewport.
      let raf = 0;
      const tick = () => {
        const goal = target();
        // Viscous easing, capped so a full pour never takes less than ~1.5s.
        const step = (goal - shown) * 0.09;
        shown += Math.sign(step) * Math.min(Math.abs(step), 0.011);
        if (Math.abs(goal - shown) < 0.0005) shown = goal;
        paint(shown);
        raf = requestAnimationFrame(tick);
      };
      new IntersectionObserver(([e]) => {
        cancelAnimationFrame(raf);
        if (e.isIntersecting) raf = requestAnimationFrame(tick);
      }, { rootMargin: "200px 0px" }).observe(section);
      completeFill = () => (boost = 1);
    }
  }

  // Cart: Shopify AJAX API + Section Rendering API for the slide-out bag.
  const root = window.Shopify?.routes?.root || "/";
  const drawer = $("[data-drawer]");
  const drawerBody = $("[data-drawer-body]");
  const bagCount = $("[data-bag-count]");
  const bagLink = $("[data-bag]");
  let lastFocus = null;

  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
    document.documentElement.classList.add("no-scroll");
    $(".drawer-panel", drawer).focus();
  };
  const closeDrawer = () => {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("no-scroll");
    setTimeout(() => (drawer.hidden = true), 600);
    lastFocus?.focus();
  };
  $$("[data-drawer-close]").forEach((el) => el.addEventListener("click", closeDrawer));
  addEventListener("keydown", (e) => e.key === "Escape" && closeDrawer());
  bagLink?.addEventListener("click", (e) => {
    if (!drawer) return;
    e.preventDefault();
    openDrawer();
  });

  // Re-render bag contents (drawer + cart page) and the count from the server.
  const refreshCart = async (sectionsHtml) => {
    let html = sectionsHtml?.["olera-cart-items"];
    if (!html) {
      const res = await fetch(`${root}?sections=olera-cart-items`);
      html = (await res.json())["olera-cart-items"];
    }
    const doc = new DOMParser().parseFromString(html, "text/html");
    const inner = doc.querySelector(".shopify-section")?.innerHTML ?? html;
    if (drawerBody) drawerBody.innerHTML = inner;
    const page = $("[data-cart-page]");
    if (page) page.innerHTML = inner;
    const cart = await (await fetch(`${root}cart.js`)).json();
    if (bagCount) bagCount.textContent = cart.item_count;
    bagLink?.setAttribute("aria-label", `Bag, ${cart.item_count} item${cart.item_count === 1 ? "" : "s"}`);
  };

  // Quantity changes inside the bag.
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-line-change]");
    if (!btn) return;
    btn.disabled = true;
    const res = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: btn.dataset.lineChange, quantity: Math.max(0, Number(btn.dataset.q)), sections: "olera-cart-items" }),
    });
    const data = await res.json();
    refreshCart(data.sections);
  });

  // Add to bag: finish the pour, add the line, open the bag.
  buyForm?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const btn = $("[data-add]", buyForm);
    const msg = $("[data-buy-msg]", buyForm);
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = "Adding…";
    msg.textContent = "";
    completeFill();
    try {
      const fd = new FormData(buyForm);
      if (!fd.get("selling_plan")) fd.delete("selling_plan");
      fd.append("sections", "olera-cart-items");
      const res = await fetch(`${root}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || "Couldn't add to bag.");
      await refreshCart(data.sections);
      setTimeout(openDrawer, 900); // let the pour land first
    } catch (err) {
      msg.textContent = err.message;
    } finally {
      btn.disabled = false;
      btn.innerHTML = label;
      renderTotal();
    }
  });
})();
